import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ActionItemIconPosition } from '../action-item/entities/action-item.entity';
import { IconSize } from '../icon/entities/icon-sizes.entity';
import { ShIconModule } from '../icon/icon.module';

@Component({
    standalone: true,
    selector: 'sh-icon-label',
    templateUrl: './icon-label.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShIconModule, RouterModule]
})
export class ShIconLabelComponent {
    @Input() label?: string;
    @Input() icon?: string;
    @Input() iconPosition?: ActionItemIconPosition = ActionItemIconPosition.Right;
    @Input() iconSize?: IconSize = IconSize.SMALL;
    @Input() iconSuperscript?: boolean = false;
    @Input() tooltip?: string = '';
}
